module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "possible-efforts-sub-menu"
  }, [_c('div', {
    staticClass: "switcher"
  }, [_c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'makingMoney'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'makingMoney'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.makingMoney.boksTekst))])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'smallAndBig'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'smallAndBig'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.smallAndBig.boksTekst))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'makingMoney'),
      expression: "selectedItem === 'makingMoney'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.makingMoney.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.customersMakingMoneyRange ? _vm.customersMakingMoneyRange[0] : 0)) + " til " + _vm._s(_vm._f("currency")(_vm.customersMakingMoneyRange ? _vm.customersMakingMoneyRange[1] : 0)) + " i timen\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.makingMoney.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.makingMoney.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerRevenue"
    }
  }), _vm._v("\n                    Er de største kunder lønsomme?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.customersColumns,
      "rows": _vm.data.making_money.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'timelog_hours_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.timelog_hours_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('CustomersLearning', 'customerRevenue')
      }
    }
  }, [_vm._v("\n                Gå til alle kunder →\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'smallAndBig'),
      expression: "selectedItem === 'smallAndBig'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.smallAndBig.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.smallAndBigRange[0].coverage_per_hour)) + " og " + _vm._s(_vm._f("currency")(_vm.smallAndBigRange[1].coverage_per_hour)) + " pr. time\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.smallAndBig.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.smallAndBig.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerGroups"
    }
  }), _vm._v("\n                    Kan vi tjene penge på både små og store kunder?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.smallAndBigColumns,
      "rows": _vm.data.small_and_big.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'bracket') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.bracket) + " kr.\n                            ")]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('CustomersLearning', 'customerRevenueGrouped')
      }
    }
  }, [_vm._v("\n                Gå til alle kunder →\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bb876fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/PossibleEfforts/customers.vue
// module id = 799
// module chunks = 0